export const getPricingInfo = () => {
  const today = new Date();
  const earlyBirdEndDate = new Date("2025-04-30T23:59:59");

  const isEarlyBird = today <= earlyBirdEndDate;

  return {
    isEarlyBird,
    regularPrice: 125,
    earlyBirdPrice: 110,
    currentPrice: isEarlyBird ? 110 : 125,
  };
};
